import React, { useContext } from 'react';

import { media } from 'context';
import { Clickable, Img, Layout, Text } from 'ds';

interface ConsumablesOnboardingRestockingBannerProps {
  size: 'sm' | 'md' | 'lg' | 'mobile';
  onBannerClick?: () => void;
}

const ConsumablesOnboardingRestockingBanner: React.FC<ConsumablesOnboardingRestockingBannerProps> = ({
  size,
  onBannerClick
}) => {
  const { isMobile, xl } = useContext(media);
  const CONFIG = {
    mobile: {
      rightHalfWidth: 124,
      height: 112,
      imgKey: 'consumables_onboarding_image_2_Fs-dx_Gmp.png?updatedAt=1750991814613',
      imgWidth: 372,
      imgHeight: 336
    },
    sm: {
      rightHalfWidth: 164,
      height: 164,
      imgKey: 'consumables_onboarding_image_2_Fs-dx_Gmp.png?updatedAt=1750991814613',
      imgWidth: 492,
      imgHeight: 492
    },
    md: {
      rightHalfWidth: 502,
      height: 172,
      imgKey: 'consumables_onboarding_banner_image_1_WkIpPLHUl.png?updatedAt=1750888892741',
      imgWidth: 1506,
      imgHeight: 516
    },
    lg: {
      rightHalfWidth: 610,
      height: 164,
      imgKey: 'consumables_onboarding_banner_image_1_WkIpPLHUl.png?updatedAt=1750888892741',
      imgWidth: 1830,
      imgHeight: 492
    }
  };

  if (size === 'mobile') {
    return (
      <Clickable
        onClick={() => {
          onBannerClick?.();
        }}
      >
        <Layout direction="row" height={CONFIG[size].height} borderRadius={16}>
          <Layout
            direction="column"
            gap={12}
            color="blue-100"
            borderBottomLeftRadius={16}
            borderTopLeftRadius={16}
            paddingX={24}
            paddingY={18}
            flexGrow={1}
          >
            <Text size="body-sm" semibold color="purple-gradient" align="left">
              Your items — restocked like magic
            </Text>
            <Text size="body-xs" semibold color="gray-900" align="left">
              Learn more
            </Text>
          </Layout>
          <Layout
            width={CONFIG[size].rightHalfWidth}
            height={CONFIG[size].height}
            minWidth={CONFIG[size].rightHalfWidth}
          >
            <Img
              srcKey={CONFIG[size].imgKey}
              alt="Consumables onboarding restocking banner"
              folder="ux"
              width={CONFIG[size].imgWidth}
              height={CONFIG[size].imgHeight}
              style={{
                borderBottomRightRadius: 16,
                borderTopRightRadius: 16,
                objectFit: 'cover'
              }}
            />
          </Layout>
        </Layout>
      </Clickable>
    );
  }

  return (
    <Layout
      direction="row"
      height={!isMobile && !xl ? undefined : CONFIG[size].height}
      minHeight={CONFIG[size].height}
      borderRadius={16}
    >
      <Layout
        direction="column"
        gap={12}
        color="blue-100"
        borderBottomLeftRadius={16}
        borderTopLeftRadius={16}
        padding={36}
      >
        <Text size="headline-md" color="purple-gradient">
          Your items — restocked like magic
        </Text>
        <Text size="body-sm">
          We don’t just deliver — we restock and organize too. All items are unpacked and placed in your kitchen
          cabinets, fridge, and restrooms.
        </Text>
      </Layout>
      <Layout style={{ flex: '1 1 50%' }}>
        <Img
          srcKey={CONFIG[size].imgKey}
          alt="Consumables onboarding restocking banner"
          folder="ux"
          width={CONFIG[size].imgWidth}
          style={{
            borderBottomRightRadius: 16,
            borderTopRightRadius: 16,
            width: '100%',
            height: '100%'
          }}
        />
      </Layout>
    </Layout>
  );
};

export default ConsumablesOnboardingRestockingBanner;
